
import React from 'react'

const Loader = ({message, heightOfLoader,marginTopLoader}) => {
    return (
        <div className="loader_background" style={{height:'100%'}}>
            <div className="spinner-border text-primary" style={{ width: '5rem', height: '5rem', role: 'status',marginTop:'22%', marginLeft: '46%' }}>
            </div>
            <span style={{ marginTop:'18%', marginLeft: '46%', marginBottom: '5%', fontWeight: 'bold' }}>{message}...</span>
            </div>

    )
}
export default Loader;